module.exports = __webpack_public_path__ + "static/media/apleona.e27bc622.png";